import { DragDropContext,Draggable,Droppable,DropResult } from "@hello-pangea/dnd";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import MenuIcon from '@mui/icons-material/Menu';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import { Autocomplete,Checkbox,Chip,FormControl,FormControlLabel,Grid,IconButton,InputLabel,MenuItem,Select,Stack,TextField } from "@mui/material";
import { SelectChangeEvent } from '@mui/material/Select';
import React,{ useContext } from "react";
import { NewFormContext } from "../../../context/NewFormContext";
import { UserContext } from "../../../context/UserContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function UnicoMultiplo({ subitem, itemId, indexSubitem }: props) {
  const { setModelo } = useContext(NewFormContext);
  const { hierarchyLabel } = useContext(UserContext);

  const mapTiposSelecao = {
    default: 'Padrão',
    user: 'Usuarios',
    cliente: hierarchyLabel.cliente,
    local: hierarchyLabel.local,
    conjunto: hierarchyLabel.conjunto,
    unidade: hierarchyLabel.unidade
  };

  function handleValue(value: string, index: number) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, selecao: subitem?.selecao?.map((av, ind) =>
                    ind === index
                      ? value
                      : av
                  )
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function handleSetType(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.target.checked;
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) => {
              if (subitem.id === indexSubitem) {
                return {
                  ...subitem,
                  tipo: checked ? 'multiple' : 'unique',
                };
              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function handlePadrao(value: number[] | number | null) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  padrao: subitem.tipo === 'multiple'
                    ? (value ? value : [])
                    : value
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function handleTipoSelecao(event: SelectChangeEvent<string | string[]>) {
    const newPadraoListaValue = event.target.value;
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                if (newPadraoListaValue !== 'default') {
                  const updatedSubitem = {
                    ...subitem,
                    selecao: null,
                    selecionados: null,
                    padrao: null,
                    tipoSelecao: newPadraoListaValue,
                  };
                  return updatedSubitem;
                } else {
                  const updatedSubitem = {
                    ...subitem,
                    tipoSelecao: newPadraoListaValue,
                    selecao: ['item 1', 'item 2'],
                  };
                  return updatedSubitem;
                }
              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function handleAddItem() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                return {
                  ...subitem,
                  selecao: [
                    ...(subitem?.selecao || []),
                    'novo item',
                  ],
                };

              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function handleRemoveItem() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                return {
                  ...subitem,
                  selecao: subitem.selecao?.slice(0, -1),
                };

              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function reorder(list: string[], startIndex: number, endIndex: number) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function handleDragEnd(result: DropResult) {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      subitem.selecao as unknown as string[],
      result.source.index,
      result.destination.index
    );

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  selecao: items
                }
                : subitem
            )
          }
          : item
      )
    }));
  };

  const truncate = (text: string) =>
    text.length > 20 ? `${text.slice(0, 20)}...` : text;

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          {(!subitem.tipoSelecao?.length || subitem.tipoSelecao === 'default')
            && <Stack direction='column' spacing={1.5} alignItems='center'>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="multiplo">
                  {(provided) => (
                    <Stack direction='column' spacing={1.4} {...provided.droppableProps} ref={provided.innerRef} width='100%'>
                      {subitem.selecao?.map((value, index) => (
                        <Draggable key={index} draggableId={`${subitem.id}|${index}`} index={index}>
                          {(provided) => (
                            <Stack direction='row' spacing={.5} key={index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                              <IconButton disabled={false}>
                                <MenuIcon />
                              </IconButton>
                              <TextField
                                fullWidth
                                value={value}
                                onChange={eve => handleValue(eve.target.value, index)} />
                            </Stack>)}
                        </Draggable>
                      ))}
                    </Stack>)}
                </Droppable>
              </DragDropContext>
              <Stack direction='row' spacing={2}>
                <IconButton onClick={handleAddItem}>
                  <AddCircleOutlineRoundedIcon />
                </IconButton>
                <IconButton disabled={(subitem.selecao as unknown as string[] | number[])?.length <= 2} onClick={handleRemoveItem}>
                  <RemoveCircleOutlineRoundedIcon />
                </IconButton>
              </Stack>
            </Stack>}
        </Grid>
        <Grid size={4}>
          <Stack direction='column' justifyContent='flex-start' alignItems='center' spacing={1.5}>
            <div style={{ width: '100%', height: '55px' }}>
              <FormControlLabel labelPlacement="start" label="Multipla escolha"
                control={<Checkbox
                  checked={subitem.tipo === 'multiple'}
                  onChange={handleSetType}
                />}
              />
            </div>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
              <Select
                value={subitem?.tipoSelecao ?? 'default'}
                label="Tipo"
                onChange={handleTipoSelecao}
              >{Object.keys(mapTiposSelecao)?.map((ele, ind) => (
                <MenuItem key={ind} value={ele}>{mapTiposSelecao[ele as keyof typeof mapTiposSelecao]}</MenuItem>
              ))
                }
              </Select>
            </FormControl>
            {(!subitem.tipoSelecao?.length || subitem.tipoSelecao === 'default')
              && <Autocomplete
                renderTags={(value, getTagProps) => {
                  const displayedTags = value.slice(0, 2);
                  return (
                    <>
                      {displayedTags?.map((option, index) => {
                        const tagProps = getTagProps({ index });
                        return (
                          <Chip
                            {...tagProps}
                            key={option.index as number}
                            label={truncate(option.nome)}
                            onDelete={tagProps.onDelete}
                          />
                        );
                      })}
                      {value.length > 2 && (
                        <Chip
                          label={`+${value.length - 2}`}
                          sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}
                        />
                      )}
                    </>
                  );
                }}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        checked={selected}
                      />
                      {option.nome}
                    </li>
                  );
                }}
                multiple={subitem.tipo === 'multiple'}
                value={
                  subitem.tipo === 'multiple'
                    ? (subitem.padrao && Array?.from(subitem?.padrao as string[])?.map((ele) => ({
                      nome: (subitem?.selecao as unknown as string[])?.[ele as unknown as string as unknown as number],
                      index: ele
                    }))) || []
                    : subitem?.padrao !== null && subitem?.padrao !== undefined
                      ? {
                        nome: (subitem?.selecao as unknown as string[])?.[subitem.padrao as unknown as string as unknown as number],
                        index: subitem.padrao
                      }
                      : null
                }
                fullWidth
                autoComplete
                getOptionLabel={(option) => option.nome ?? ''}
                getOptionKey={(option) => option.index as number}
                isOptionEqualToValue={(option, value) => option.nome === value.nome}
                options={(subitem?.selecao as unknown as string[])
                  ?.map((nome: string, index: number) => ({
                    nome: nome,
                    index: index
                  })) ?? []}
                renderInput={(params) => <TextField {...params} label={'Valor padrão'} />}
                onChange={(event, newValue) => {
                  event.preventDefault();
                  if (newValue === null || (Array.isArray(newValue) && newValue.length === 0)) {
                    handlePadrao([]);
                  } else if (Array.isArray(newValue)) {
                    handlePadrao(newValue?.map((ele) => ele.index as number));
                  } else {
                    handlePadrao(newValue?.index as number);
                  }
                }}
              />}
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
}
